import "./App.css";

function App() {
  return (
    <div className="App">
      <p>Hello Good Morning</p>
    </div>
  );
}

export default App;
